const getSavedCalculatorData = require("./getSavedCalculatorData");

/**
 * @param outputUrl {string} // The ROI calculator PDF download URL
 * @return {RoiCalculatorFormData | null}
 */
module.exports = function getSavedCalculatorDataWithOutputUrl(outputUrl) {
    const calculatorData = getSavedCalculatorData();

    if (calculatorData) {
        calculatorData['wvc_OutputURL'] = outputUrl;
    }

    return calculatorData;
}